export default class Slider {
    constructor(obj) {
        this.obj = obj;
        this.id = obj.attr('id');
        this.init();
    }

    init() {
        this.createGlobalSlider();
        this.highlightFirstPaginationSlide();
        this.addSliderListeners();
        this.addPaginationSliderListeners();
        this.syncFancyBox();
    }

    createGlobalSlider() {
        window['swiper_' + this.id] = this.slider = new Swiper('#' + this.id, {
            navigation: {
                nextEl: '#' + this.id + ' .gallery__button_next',
                prevEl: '#' + this.id + ' .gallery__button_prev',
            }
        });

        window['paginationSwiper_' + this.id] = this.paginationSlider = new Swiper('#' + this.id + '_pagination', {
            slidesPerView: 6,
            slidesPerColumn: 2,
            spaceBetween: 5,
            slidesPerColumnFill: 'row',
            navigation: {
                nextEl: '#' + this.id + '_pagination .gallery-thumbs__button_next',
                prevEl: '#' + this.id + '_pagination .gallery-thumbs__button_prev',
            },
            breakpoints: {
                449: {
                    slidesPerView: 3,
                    slidesPerColumn: 2,
                }
            }
        });
    }

    highlightFirstPaginationSlide() {
        $('#' + this.id + '_pagination .image-pagination__item').eq(0).addClass('image-pagination__item_active');
    }

    addSliderListeners() {
        var self = this;
        this.slider.on('slideChange', function () {
            $('#' + self.id + '_pagination .image-pagination__item_active').removeClass('image-pagination__item_active');
            $('#' + self.id + '_pagination .image-pagination__item').eq(this.realIndex).addClass('image-pagination__item_active');
        });
    }

    addPaginationSliderListeners() {
        var self = this;
        $('#' + self.id + '_pagination .image-pagination__item').click(function() {
            let targetIndex = $('#' + self.id + '_pagination .image-pagination__item').index(this);
            $(this).parents('#' + self.id + '_pagination').find('.image-pagination__item_active').removeClass('image-pagination__item_active');
            $(this).addClass('image-pagination__item_active');
            self.slider.slideTo(targetIndex);
        });
    }

    syncFancyBox() {
        var self = this;

        $('[data-fancybox="' + self.id + '"]').fancybox({
            afterShow: function(instance, slide) {
                self.slider.slideTo(slide.index);
            }
        });
    }
}